module.exports = __webpack_public_path__ + "img/ico_audience-origin.4818dac3.png";